import { BaseSubChain } from 'domain/entities/monomer-chains/BaseSubChain';

export class EmptySubChain extends BaseSubChain {}
